export function filter(data, options) {
  var callback = options.callback;

  if (callback) {
    data.dataArray = data.dataArray.filter(callback);
  }

  return data;
}
//# sourceMappingURL=filter.js.map